import { supabase } from "@/integrations/supabase/client";
import {
  bootstrapFanSession,
  bumpFanInsight,
} from "@/lib/fanProfile.functions";

const KEY = "ss2026_session_id";

export function getSessionId(): string {
  if (typeof window === "undefined") return "ssr";
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(KEY, id);
  }
  return id;
}

export async function bootstrapSession() {
  if (typeof window === "undefined") return;
  const session_id = getSessionId();
  try {
    await bootstrapFanSession({
      data: { session_id, country: "US", city: "Miami" },
    });
  } catch (e) {
    console.warn("[session] bootstrap failed", e);
  }
}

type InsightField =
  | "predictions_made"
  | "chat_messages_sent"
  | "goal_celebrations_seen"
  | "audio_sync_count";

export async function bumpInsight(field: InsightField, by = 1) {
  if (typeof window === "undefined") return;
  const session_id = getSessionId();
  try {
    await bumpFanInsight({ data: { session_id, field, by } });
  } catch (e) {
    console.warn("[insight] bump failed", field, e);
  }
}

export async function logChatMessage(role: "user" | "ai", content: string, model?: string) {
  if (typeof window === "undefined") return;
  try {
    await supabase.from("ai_chat_logs").insert({
      session_id: getSessionId(),
      role,
      content,
      model: model ?? null,
    });
  } catch (e) {
    console.warn("[chatlog] insert failed", e);
  }
}